// extracted by mini-css-extract-plugin
var _1 = "INXFa";
var _2 = "m3wGy";
var _3 = "dILWC";
var _4 = "U5YuW";
var _5 = "WwK4v";
export { _1 as "body", _2 as "item", _3 as "joinTypeIcon", _4 as "name", _5 as "typeIcon" }
